module.exports = __webpack_public_path__ + "static/hero-background-4a8f4158b48127272943484e2a1c3f31.png";